<template>
  <el-form
    v-loading="loading"
    ref="addEditSchoolRef"
    :model="ruleForm"
    :rules="rules"
    label-width="90px"
    class="demo-ruleForm"
    size="large"
    status-icon
  >
    <el-form-item label="院校名称" prop="name">
      <el-input
        v-model="ruleForm.name"
        placeholder="请填写院校名称"
        class="big_input"
      />
    </el-form-item>

    <el-row>
      <el-col :span="10">
        <el-form-item label="院校性质" prop="nature">
          <el-select
            v-model="ruleForm.nature"
            class="m-2 small_input"
            placeholder="请选择院校性质"
            @change="searchData"
          >
            <el-option
              v-for="item in natureList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <el-form-item label="院校类别" prop="types">
          <el-select
            v-model="ruleForm.types"
            class="m-2 small_input"
            placeholder="请选择院校类别"
            @change="searchData"
          >
            <el-option
              v-for="item in typesList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10">
        <el-form-item label="联系电话" prop="tel">
          <el-input
            class="small_input"
            type="number"
            v-model.number="ruleForm.tel"
            placeholder="请填写联系电话"
            maxlength="11"
          />
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <el-form-item label="所属城市" prop="cityAddress">
          <el-select
            v-model="ruleForm.cityAddress"
            class="m-2 small_input"
            placeholder="请选择所属城市"
            @change="searchData"
          >
            <el-option
              v-for="item in allCity"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item label="详细地址" prop="address">
      <el-input
        class="middle_input"
        v-model="ruleForm.address"
        placeholder="请填写院校详细地址"
        clearable
      ></el-input>
      <el-button type="primary" @click="openMap"
        ><i class="el-icon-delete-location"></i
        >&nbsp;点击设置院校地址</el-button
      >
    </el-form-item>
    <el-row>
      <el-col :span="10">
        <el-form-item label="院校经度" prop="long">
          <el-tooltip
            class="tooltip_span"
            effect="dark"
            content="院校的经纬度坐标(经度)"
            placement="top-start"
          >
            <el-input
              style="width: 180px"
              disabled
              v-model="ruleForm.long"
              placeholder="院校经度"
              clearable
            ></el-input>
          </el-tooltip>
          <span class="mag_left">度</span>
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <el-form-item label="院校经度" prop="long">
          <el-tooltip
            class="tooltip_span"
            effect="dark"
            content="院校的经纬度坐标(纬度)"
            placement="top-start"
          >
            <el-input
              style="width: 180px"
              disabled
              v-model="ruleForm.lat"
              placeholder="院校纬度"
              clearable
            ></el-input>
          </el-tooltip>
          <span class="mag_left">度</span>
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item label="热门专业" prop="popularMajor">
      <el-col :span="24">
        <el-tag
          v-for="(item, index) in ruleForm.popularMajor"
          :key="item"
          closable
          @close="delTag('popularMajor', index, ruleForm.popularMajor)"
        >
          {{ item }}
        </el-tag>
      </el-col>
      <el-col :span="24" v-if="ruleForm.popularMajor.length !== 10">
        <el-input
          class="middle_input"
          v-model="major"
          placeholder="专业名称长度不能超过15个字"
          maxlength="15"
          clearable
        ></el-input>
        <el-button
          v-if="ruleForm.popularMajor.length !== 10"
          type="primary"
          @click="addTag('popularMajor', major, ruleForm.popularMajor)"
          plain
        >
          <el-icon> <Plus /> </el-icon>&nbsp;添加
        </el-button>
      </el-col>
    </el-form-item>
    <el-form-item label="院校特色" prop="features">
      <el-col :span="24">
        <el-tag
          v-for="(item, index) in ruleForm.features"
          :key="item"
          closable
          @close="delTag('features', index, ruleForm.features)"
        >
          {{ item }}
        </el-tag>
      </el-col>
      <el-col v-if="ruleForm.features.length !== 6">
        <el-input
          class="big_input"
          v-model="features"
          placeholder="单个标签长度30个字以内"
          maxlength="30"
          clearable
        ></el-input>
        <el-button
          v-if="ruleForm.features.length !== 6"
          type="primary"
          @click="addTag('features', features, ruleForm.features)"
          plain
        >
          <el-icon> <Plus /> </el-icon>&nbsp;添加
        </el-button>
      </el-col>
    </el-form-item>
    <el-form-item label="排序值" prop="orderIndex">
      <el-tooltip
        class="item"
        effect="dark"
        content="排序值只能输入数字(整数),且排序值不能重复;前台院校列表页根据排序值从小到大依次排序"
        placement="top"
      >
        <el-input
          class="small_input"
          v-model.number="ruleForm.orderIndex"
          type="number"
          placeholder="请填写排序值"
          @mousewheel.prevent
          @keyup="prevent($event)"
        />
      </el-tooltip>
    </el-form-item>
    <el-form-item label="院校图片" prop="logoPath">
      <ImgUpload
        v-if="childShow"
        :type="3"
        :limit="1"
        ref="addEditImgRef"
        :imagePath="ruleForm.logoPath"
        @change-image="changeImage"
      ></ImgUpload>
    </el-form-item>
    <el-form-item label="主要奖项" prop="award">
      <el-input
        v-model="ruleForm.award"
        :autosize="{ minRows: 2, maxRows: 4 }"
        type="textarea"
        placeholder="请填写主要奖项"
      />
    </el-form-item>
    <el-form-item label="院校描述" prop="contents">
      <WangEditor
      :isDecode="false"
        v-if="childShow"
        :content="ruleForm.contents"
        @changeContent="setContent"
      />
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" size="large" @click="submitForm(addEditSchoolRef)"
      >提交</el-button
    >
  </div>
  <el-dialog
    class="map_dialog"
    title="设置院校位置"
    v-model="showBaiDuMap"
    width="780px"
    :close-on-click-modal="false"
    append-to-body
  >
    <div>
      <BaiduMap
        v-show="showBaiDuMap"
        @close-map="openMap"
        @change-map="changeMap"
        :lngLat="{
          lng: ruleForm.long,
          lat: ruleForm.lat,
        }"
        :mapZoom="ruleForm.zoom"
      ></BaiduMap>
    </div>
  </el-dialog>
</template>

<script>
import {
  getAllCities,
  getSchoolPt,
  addSchoolPt,
  modifySchoolPt,
} from "network/pbSchool.js";
import WangEditor from "components/wangEditor/WangEditor.vue";
import BaiduMap from "components/BaiduMap.vue";
import ImgUpload from "components/ImgUpload.vue";
import { toRefs, reactive, ref, unref, onMounted, toRaw } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { textFilter, isEditorNull } from "common/utils";
export default {
  name: "AddEditPbSchool",
  components: {
    WangEditor,
    BaiduMap,
    ImgUpload,
  },
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editId: Number,
    natureList: Array,
    typesList: Array,
  },
  setup(props, { emit }) {
    const addEditSchoolRef = ref();
    const addEditImgRef = ref();
    const data = reactive({
      loading: false,
      childShow: false,
      ruleForm: {
        name: null,
        tel: null,
        cityAddress: null,
        nature: null,
        types: null,
        address: null,
        long: null,
        lat: null,
        popularMajor: [],
        features: [],
        logoPath: "",
        award: null,
        contents: "",
        orderIndex: null,
      },
      rules: {
        name: [
          { required: true, message: "请填写院校名称" },
          { min: 2, max: 20, message: "院校名称为2-20字" },
        ],
        tel: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur",
          },
        ],
        logoPath: [
          {
            required: true,
            message: "请选择院校图片",
            trigger: "blur",
          },
        ],
        nature: [
          {
            required: true,
            message: "请选择院校性质",
            trigger: "change",
          },
        ],
        types: [
          {
            required: true,
            message: "请选择院校类别",
            trigger: "change",
          },
        ],
        cityAddress: [
          {
            required: true,
            message: "请选择所属城市",
            trigger: "change",
          },
        ],
        popularMajor: [
          {
            required: true,
            message: "请填写热门专业",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请设置院校详细地址",
            trigger: "change",
          },
        ],
        long: [
          {
            required: true,
            message: "请设置院校经纬度(经度)",
            trigger: "change",
          },
        ],
        lat: [
          {
            required: true,
            message: "请设置院校经纬度(纬度)",
            trigger: "change",
          },
        ],
        contents: [
          { required: true, message: "请填写院校内容", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let isEmpty = isEditorNull(textFilter(value));
              if (isEmpty) {
                callback(new Error("请填写院校内容"));
              } else {
                callback();
              }
            },
          },
        ],
        orderIndex: [
          {
            required: true,
            message: "请设置院校排序值",
            trigger: "blur",
          },
        ],
      },
      major: [], //热门专业 输入项
      features: [], //院校特色 输入项
      placeholder1: "请在这里输入院校描述",
      showBaiDuMap: false, //地图弹窗
      allCity: [], //所有城市
    });

    //编辑请求院校详情
    if (props.editId > 0) {
      data.loading = true;
      getSchoolPt(props.editId)
        .then((result) => {
          if (result && result.code == 1) {
            data.loading = false;
            data.childShow = true;
            data.ruleForm = result.result;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      data.childShow = true;
    }

    //排序值输入限制
    const prevent = (e) => {
      var keynum = window.event ? e.keyCode : e.which; //获取键盘码
      if (keynum == 189 || keynum == 190 || keynum == 109 || keynum == 110) {
        ElMessage.warning("禁止输入小数以及负数");
        e.target.value = "";
      }
    };
    //添加关键字或标签:isTag是否是标签主要用于清除输入框内容
    const addTag = (type, val, valAll) => {
      if (type == "popularMajor") {
        if (val == "" || val == null || val.length < 2) {
          ElMessage.error("请输入2-15个字");
          return false;
        }
        if (valAll.length >= 10) {
          data.major = "";
          ElMessage.error("最多只能设置10个");
          return false;
        }
        var index = valAll.indexOf(val);
        if (index >= 0) {
          ElMessage.error("关键字[" + val + "]已存在");
          return false;
        }
        valAll.push(val);
        data.ruleForm.popularMajor = valAll;
        ElMessage({ message: "添加成功！", type: "success" });
        data.major = "";
      }
      if (type == "features") {
        if (val == "" || val == null || val.length < 2) {
          ElMessage.error("请输入2-30个字");
          return false;
        }
        if (valAll.length >= 6) {
          data.features = "";
          ElMessage.error("最多只能设置6个");
          return false;
        }
        var index = valAll.indexOf(val);
        if (index >= 0) {
          ElMessage.error("关键字[" + val + "]已存在");
          return false;
        }
        valAll.push(val);
        data.ruleForm.features = valAll;
        ElMessage({ message: "添加成功！", type: "success" });
        data.features = "";
      }
    };
    //删除关键字或标签
    const delTag = (type, index, valAll) => {
      valAll.splice(index, 1);
      ElMessage({ message: "删除成功！", type: "success" });
    };
    //打开地图
    const openMap = () => {
      data.showBaiDuMap = !data.showBaiDuMap;
    };
    //获取地图组件传递的经纬度
    const changeMap = (address, lnglat, zoom) => {
      data.ruleForm.address = address;
      data.ruleForm.long = lnglat.lng;
      data.ruleForm.lat = lnglat.lat;
      data.ruleForm.zoom = zoom;
    };
    //获取图片上传组件传过来的
    const changeImage = (arr) => {
      if (arr && arr.length > 0) {
        data.ruleForm.logoPath = arr[0].url;
        addEditSchoolRef.value.clearValidate("logoPath");
      } else {
        data.ruleForm.logoPath = "";
      }
    };
    //获取富文本编辑器传过来的
    const setContent = (val) => {
      if (val) {
        data.ruleForm.contents = val;
        // data.ruleForm.contents = encodeURIComponent(val);
        addEditSchoolRef.value.clearValidate("contents"); //移除校验结果
      }
    };
    // 提交
    const submitForm = async () => {
      const form = unref(addEditSchoolRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          var pattern =
            /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
          if (!pattern.test(data.ruleForm.tel)) {
            ElMessage.warning("请输入正确格式的联系电话");
            return false;
          }
          updataAdd(data.ruleForm);
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    async function updataAdd(data) {
      data.loading = true;
      let result = "";
      if (props.editId > 0) {
        data.id = props.editId;
        result = await modifySchoolPt(data);
      } else {
        result = await addSchoolPt(data);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
        });
        if (addEditImgRef.value) {
          addEditImgRef.value.submitData(data.logoPath);
        }
        emit("close-dialog");
        emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
                  });
      }
    }
    onMounted(() => {
      // 获取普本院校所有的城市
      getAllCities().then((res) => {
        if (res.code == 1) {
          data.allCity = res.result;
        } else {
          ElMessage.error(res.message);
        }
      });
    });
    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      addEditSchoolRef.value.resetFields(); // 关闭弹窗 判断图片删除
      if (addEditImgRef.value) {
        addEditImgRef.value.cancelData();
      }
    };
    return {
      ...toRefs(data),
      addEditSchoolRef,
      addEditImgRef,
      changeImage,
      setContent,
      prevent,
      addTag,
      delTag,
      openMap,
      changeMap,
      submitForm,
      resetForm,
    };
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 540px;
  overflow-y: scroll;
}
.tooltip_span {
  display: inline-block;
}
.mag_left {
  margin-left: 10px !important;
}
.mag_right {
  margin-right: 10px !important;
}
</style>

